import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { CreateRecipientOnEnter } from '../components/symphony/onboarding/CreateRecipientOnEnter';
import { usePageLoadBi } from '../lib/use-page-load-bi';
import { useCaptureReferrer } from '../lib/use-capture-referrer';

const PAGE = { page_name: 'signup_start_page', page_version: 'v3_signup_start' } as const;

// Where a signed-in caller with no recipient starts: this creates one and hands them to their onboarding
// conversation. All it ever shows is the loader, so the URL is the only thing a user reads here — which is
// the reason it is not `/onboarding/phone`, where the path named a form that no longer exists. `welcome`
// rather than something like `new` because it is the one word here a user can read and have it be true.
//
// It MUST stay inside the gate's `TENANT_FREE_PATHS`. The gate redirects any non-exempt path to
// `firstOnboardingStep()`, without comparing it to the path being requested, so an unexempted route that the
// gate points at has its own document 302'd to itself — a redirect loop on the one path a new user must load.
//
// It is also where an invite's `?ref=` is caught, and this is the ONLY route where that can happen: the gate
// sends a caller with no metasite to a bare `/welcome`, so a `ref` arriving on any other path is dropped
// server-side before a page runs. `useCaptureReferrer` must therefore run here, and before
// `CreateRecipientOnEnter` replaces the URL with the bare mount once the recipient exists.
export default function SignupStart() {
  usePageLoadBi(PAGE);
  useCaptureReferrer();
  return (
    <GenericEventsRouteProvider value="signup-start">
      <CreateRecipientOnEnter />
    </GenericEventsRouteProvider>
  );
}
